import Dashboard from './Dashboard.vue';
import BuildingSwitcher from './components/BuildingSwitcher.vue';

export { BuildingSwitcher };
export default Dashboard;
